import api from '@/utils/api';

const controller = 'v1.0/parceiroProduto';
const parceiroProdutoExport = Object.assign(
    {},
    api.GetCrud(controller, ["none"]),
    {
        CadastroParceiroProduto: function (model) {
            return api.Axios.Post(controller, model);
        },
        AtualizarParceiroProduto: function (model) {
            return api.Axios.PutWithoutId(controller, model);
        },
        GetById: function (id) {
            return api.Axios.Get(controller + "/" + id);
        },
        GetTodos: function () {
            return api.Axios.Get(controller + "/Todos");
        },
        Delete: function (id) {
            return api.Axios.Delete(controller + "/" + id);
        },
    }
);

export default parceiroProdutoExport;